import React, { MouseEvent } from 'react';
import { ThemeProvider } from 'styled-components';
import Icon from '../../../Icon/Icon';
import { IconTypes } from '../../../../helpers/constants';
import Button from '../../../Button/Button';
import { BlockHeaderIconWrapper } from './styles';

export interface BlockHeaderIconProps {
  left?: boolean;
  isLoading?: boolean;
  actionIsLoading?: boolean;
  type?: IconTypes;
  callback?: (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  /** @ignore */
  'data-testid'?: string | number;
}

function BlockHeaderIcon(props: BlockHeaderIconProps) {
  const { left, isLoading, actionIsLoading, type, callback } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        left,
      })}
    >
      <BlockHeaderIconWrapper data-testid={props['data-testid']}>
        <Button isLoading={isLoading || actionIsLoading} onClick={callback} type="aura" size="full">
          <Icon type={type} size="xxl" />
        </Button>
      </BlockHeaderIconWrapper>
    </ThemeProvider>
  );
}

export default BlockHeaderIcon;
